import React from "react"
const TermDates2026 = () => (
  <>
    <h5 className="blue-text text-lighten-2">
      Term dates for next academic year (Sept 2026 - July 2027)
    </h5>  
    <br />
    <div className="termDates-header">Back to preschool! The start of the academic year</div>
    <i>Autumn Term: Wednesday 2 September 2026 – Friday 23 October 2026</i>
    <br />
    <i>Half Term: Monday 26 October 2026 - Friday 30 October 2026</i>
    <br />
    <i>Autumn Term (continued): Monday 2 November 2026 – Friday 11 December 2026</i>

    <div className="termDates-header">Fresh start after winter break</div>
    <i>Spring Term: Monday 4 January 2027 – Friday 12 February 2027</i>
    <br />
    <i>Half Term: Monday 15 February 2027 - Friday 19 February 2027</i>
    <br />
    <i>Spring Term (continued): Monday 22 February 2027 – Thursday 25 March 2027</i>

    <div className="termDates-header">Final term — leading into summer holidays!</div>
    <i>Summer Term: Monday 12 April 2027 – Friday 28 May 2027</i>
    <br />
    <i>Half Term: Monday 31 May 2027 - Friday 4 June 2027</i>
    <br />
    <i>Summer Term (continued): Monday 7 June 2027 – Thursday 22 July 2027</i>
    <br />
    <p className="grey-text text-darken-2">
      <span className="termDates-header">*</span>
      Only Parents, siblings and grandparents are welcomed to all the parties.
      <br />
      During the term time, children are not authorised to take
      holidays unless it is an emergency for up to 10 days. Local
      authority will not provide funding and the child place will be
      withdrawn from the preschool.
    </p>
  </>
)
export { TermDates2026 as default }
